// extracted by mini-css-extract-plugin
module.exports = {"outdoor-recreation-B1":"B1_outdoor-recreation-B1__SdySE"};